import AutomaticRepliesOption from 'owa-automatic-replies-option/lib/AutomaticRepliesOption';
import { OptionSubCategory } from 'owa-options-core';
import { initLoadMailboxAutomaticRepliesConfiguration } from 'owa-automatic-replies-option';

const automaticRepliesSubCategory: OptionSubCategory = {
    key: 'automaticReplies',
    titleStringKey: 'optionSubcategory_automaticReplies',
    options: [AutomaticRepliesOption],
    onSelected: () => {
        return initLoadMailboxAutomaticRepliesConfiguration();
    },
};

export default automaticRepliesSubCategory;
